import { Zone } from "./Zone";

export class Store {
    
    storeId: string;
    storeLabel: string;
    city: string;
    postalCode: string;
    emails: string[];
    zones: Zone[];
}